import TeamManagementPage from 'components/UI/teamManagementPage/TeamManagementPage'

function TeamManagementPageWrapper() {
    return <TeamManagementPage />
}

export default TeamManagementPageWrapper

